import { useMergeRefs } from '@/hooks/useMergeRefs'
import clsx from 'clsx'
import { forwardRef, ReactNode, useContext, useRef } from 'react'
import { TabsContext, TabsDirection } from './TabsContext'
import styles from './TabsList.module.scss'
import { UseTabKeyHandlerOrientation, useTabsListKeyHandler } from './hooks/useTabsListKeyHandler'

const orientationMap: Record<TabsDirection, UseTabKeyHandlerOrientation> = {
  'row': 'horizontal',
  'row-reverse': 'horizontal',
  'column': 'vertical',
  'column-reverse': 'vertical',
}

export interface TabsListProps {
  children: ReactNode
  className?: string
}

export const TabsList = forwardRef<HTMLDivElement, TabsListProps>(
  ({ children, className }, ref) => {
    const { direction, value, onChange, tabsRef, wrapperId, variant } = useContext(TabsContext)
    const tabListRef = useRef<HTMLDivElement>(null)
    useTabsListKeyHandler({
      value,
      onChange,
      tabsRef,
      tabListRef,
      orientation: orientationMap[direction],
    })
    const mergedRefs = useMergeRefs(ref, tabListRef)

    return (
      <div
        className={clsx(styles.tabsList, styles[direction], styles[variant], className)}
        data-testid="mui-tabs"
        ref={mergedRefs}
        role="tablist"
        aria-label={`tablist-${wrapperId}`}
      >
        {children}
      </div>
    )
  },
)
